
define(
	'Ames.HomeStore.HomeStore'
,   [
		'Ames.HomeStore.HomeStore.View',
		'StoreLocator.List.View.Extension',
		'Location.VenueDetails.View.Extension'
	]
,   function (
		HomeStoreView,
		StoreLocatorListViewExtension,
		LocationVenueDetailsViewExtension
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// var layout = container.getComponent('Layout');
			
			// if(layout)
			// {
			// 	layout.addChildView('Close.Message', function() { 
			// 		return new AmesHomeStoreCloseMessageView({ container: container });
			// 	});
			// }

		}
	};
});
